// utils/dateRanges.js
import moment from "moment";

moment.locale("en", {
  week: {
    dow: 6,
  },
});
export function getTodayRange() {
  const d = moment().startOf("day");
  return [d.toDate(), d.toDate()];
}

export function getYesterdayRange() {
  const d = moment().subtract(1, "day").startOf("day");
  return [d.toDate(), d.toDate()];
}

export function getLastThreeDaysRange() {
  const start = moment().subtract(3, "days").startOf("day");
  const end = moment().subtract(1, "day").endOf("day");
  return [start.toDate(), end.toDate()];
}

export function getThisWeekRange() {
  const start = moment().startOf("week");

  const end = moment();

  return [start.toDate(), end.toDate()];
}

export function getLastWeekRange() {
  const start = moment().subtract(1, "week").startOf("week");
  const end = moment().subtract(1, "week").endOf("week");
  return [start.toDate(), end.toDate()];
}

export function getThisMonthRange() {
  const start = moment().startOf("month");
  const end = moment();
  return [start.toDate(), end.toDate()];
}

export function getLastMonthRange() {
  const start = moment().subtract(1, "month").startOf("month");
  const end = moment().subtract(1, "month").endOf("month");
  return [start.toDate(), end.toDate()];
}
